import { Navigate } from "react-router-dom";
import { useAuthStore } from "../../stores/authStore";

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const isAuthenticated = useAuthStore(
    (state: { isAuthenticated: any }) => state.isAuthenticated
  );
  return isAuthenticated ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
